module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Пользователи сайта")]), _vm._v(" "), (((_vm.commonData.isLoaded == true) && (_vm.users.length != 0))) ? _c('div', [_c('entity-manager', {
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "data": _vm.users,
      "options": _vm.usersEntityManagerOptions
    },
    scopedSlots: _vm._u([{
      key: "dataItemFieldTableView",
      fn: function(viewProps) {
        return [(viewProps.column.field == 'updatedAt') ? _c('span', [_vm._v("\n          " + _vm._s(_vm._f("formatDate")(viewProps.dataRow.val[viewProps.column.field])) + "\n        ")]) : (viewProps.column.field == 'GroupID') ? _c('span', [((viewProps.dataRow.val[viewProps.column.field] != -1) && (viewProps.dataRow.val['Deleted'] != -1)) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.commonData.usersGroups[viewProps.dataRow.val[viewProps.column.field]].Name) + "\n          ")]) : _vm._e()]) : (viewProps.column.field == 'deleted') ? _c('span', [(viewProps.dataRow.val['deleted'] == true) ? _c('span', [_vm._v("Удален")]) : _c('span', [_vm._v("Нет")])]) : _c('span', [_vm._v("\n          " + _vm._s(viewProps.dataRow.val[viewProps.column.field]) + "\n      ")])]
      }
    }, {
      key: "dataItemFieldEditView",
      fn: function(viewProps) {
        return [(viewProps.fieldKey == 'id') ? _c('span', [_vm._v("\n          " + _vm._s(viewProps.editingDataRow.val[viewProps.fieldKey]) + "\n        ")]) : (viewProps.fieldKey == 'deleted') ? _c('span', [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (viewProps.editingDataRow.val[viewProps.fieldKey]),
            expression: "viewProps.editingDataRow.val[viewProps.fieldKey]"
          }],
          staticStyle: {
            "width": "100%",
            "height": "32px",
            "background-color": "#fff"
          },
          attrs: {
            "filterable": "",
            "placeholder": "Выберите значение"
          },
          on: {
            "change": [function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              var $$exp = viewProps.editingDataRow.val,
                $$idx = viewProps.fieldKey;
              if (!Array.isArray($$exp)) {
                viewProps.editingDataRow.val[viewProps.fieldKey] = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
              } else {
                $$exp.splice($$idx, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
              }
            }, function($event) {
              viewProps.editingDataRow.val[viewProps.fieldKey] == 'true' ? viewProps.editingDataRow.val[viewProps.fieldKey] = true : viewProps.editingDataRow.val[viewProps.fieldKey] = false
            }]
          }
        }, [_c('option', {
          attrs: {
            "value": "true"
          }
        }, [_vm._v("Удален")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "false"
          }
        }, [_vm._v("Нет")])])]) : (viewProps.fieldKey == 'GroupID') ? _c('span', [_c('Select', {
          attrs: {
            "filterable": "",
            "placeholder": "Выберите группу"
          },
          model: {
            value: (viewProps.editingDataRow.val[viewProps.fieldKey]),
            callback: function($$v) {
              var $$exp = viewProps.editingDataRow.val,
                $$idx = viewProps.fieldKey;
              if (!Array.isArray($$exp)) {
                viewProps.editingDataRow.val[viewProps.fieldKey] = $$v
              } else {
                $$exp.splice($$idx, 1, $$v)
              }
            },
            expression: "viewProps.editingDataRow.val[viewProps.fieldKey]"
          }
        }, _vm._l((_vm.commonData.usersGroups), function(item) {
          return (item != null) ? _c('Option', {
            key: item.id,
            attrs: {
              "value": item.id
            }
          }, [_vm._v(_vm._s(item.Name))]) : _vm._e()
        }))], 1) : _c('span', [_c('Input', {
          staticStyle: {
            "width": "100%"
          },
          model: {
            value: (viewProps.editingDataRow.val[viewProps.fieldKey]),
            callback: function($$v) {
              var $$exp = viewProps.editingDataRow.val,
                $$idx = viewProps.fieldKey;
              if (!Array.isArray($$exp)) {
                viewProps.editingDataRow.val[viewProps.fieldKey] = $$v
              } else {
                $$exp.splice($$idx, 1, $$v)
              }
            },
            expression: "viewProps.editingDataRow.val[viewProps.fieldKey]"
          }
        })], 1)]
      }
    }])
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78ac4ae2","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CMSX/UsersSite.vue
// module id = 380
// module chunks = 0